import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class TabMixin extends Vue {
	tabsAttrs = {
		// background-color="transparent"
		class: 'mt-0',
		height: '30',
	};

	tabAttrs = {
		class: 'pt-1 pb-1 mb-1 mt-0 field-title text-none',
		color: 'primary darken-1',
	};
}
